import { render, staticRenderFns } from "./DeviceTable2Header.vue?vue&type=template&id=7c982bb7&scoped=true&"
import script from "./DeviceTable2Header.vue?vue&type=script&lang=js&"
export * from "./DeviceTable2Header.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTable2Header.vue?vue&type=style&index=0&id=7c982bb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c982bb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VSelect,VTextField})
